// src/components/Navbar.js
import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobileNav = () => {
    setMobileOpen(!mobileOpen);
  };

  const navLinks = [
    { name: "Web Development", link: "/web" },
    { name: "Artificial Intelligence", link: "/AI" },
    { name: "Data Analytics", link: "/dataAnalytics" },
    // { name: "Blog Posts", link: "/blog" },
    { name: "Contact Us", link: "/contact" },
  ];

  return (
    <header className="navbar">
      {/* Brand */}
      <div className="brand">
        <Link to="/">
          <img
            src="/assets/images/Tearabyte-Software-SolutionsSmall.png"
            alt="Logo"
          />
        </Link>
      </div>

      {/* Desktop Nav */}
      <nav className="nav-links">
        {navLinks.map((item, idx) => (
          <div className="nav-item" key={idx}>
            <Link className="nav-link" to={item.link}>
              {item.name}
            </Link>
            <div className="blob"></div>
          </div>
        ))}
      </nav>

      {/* Burger */}
      <button
        className="mobile-toggle"
        onClick={toggleMobileNav}
        aria-label="Toggle navigation"
      >
        {mobileOpen ? "×" : "☰"}
      </button>

      {/* Mobile Menu */}
<div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
  {navLinks.map((item) => (
    <Link
      key={item.link}
      to={item.link}
      className="mobile-link"
      onClick={() => setMobileOpen(false)}
    >
      {item.name}
    </Link>
  ))}
</div>

    </header>
  );
};

export default Navbar;
